import type { HistoryRowDto, HistoryTarget } from '@pb/shared';
import { asList, get, query } from './client';

export const getHistory = async (target: HistoryTarget, id: number, limit = 200) =>
  asList(await get<HistoryRowDto[] | { items: HistoryRowDto[] }>(`/history/${target}/${id}${query({ limit })}`));
